import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50 flex items-center justify-center px-4">
      <div className="text-center">
        <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-primary-100 flex items-center justify-center">
          <i className="ri-error-warning-line text-3xl text-primary-600"></i>
        </div>
        <h1 className="text-5xl md:text-6xl font-bold text-foreground-950 mb-3">404</h1>
        <p className="text-foreground-500 text-lg mb-2">页面未找到</p>
        <p className="text-foreground-400 text-sm mb-8">您访问的页面不存在或已被移除</p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full font-medium text-sm transition-colors whitespace-nowrap"
        >
          <i className="ri-arrow-left-line"></i> 返回首页
        </Link>
      </div>
    </div>
  );
}